import React from 'react';
import { EmptyStateContainer, EmptyStateText } from './EmptySearchState.styles';

const EmptySearchState = () => {
  return (
    <EmptyStateContainer>
      <EmptyStateText>No results yet. Adjust filters and click Search.</EmptyStateText>
    </EmptyStateContainer>
  );
};

export default EmptySearchState;
